import type { FileBaseAdapter } from "@mobsuccess-devops/lcm-client/schemas/fileBaseAdapter";
import { FileTypeEnum } from "@mobsuccess-devops/lcm-client/schemas/fileTypeEnum";
import { isEnum } from "@mobsuccess-devops/utilities/enums";

type BuildMediaSourceOptions = {
  allowAudioDuration?: boolean;
};

export function buildMediaSource(
  file: File,
  path: string,
  options?: BuildMediaSourceOptions,
): FileBaseAdapter {
  if (!file.metadata.loaded) {
    throw new Error(
      "File metadata must be loaded before building a media source",
    );
  }
  if (!isEnum(FileTypeEnum, file.type)) {
    throw new Error(`Invalid file type for media source: ${file.type}`);
  }

  const { metadata } = file;
  const allowAudioDuration = options?.allowAudioDuration ?? false;
  const includeDuration =
    metadata.type === "video" ||
    (allowAudioDuration && metadata.type === "audio");

  return {
    path,
    type: file.type,
    width: "width" in metadata ? metadata.width : undefined,
    height: "height" in metadata ? metadata.height : undefined,
    duration: includeDuration ? metadata.duration : undefined,
  };
}
